"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randBetween = randBetween;
exports.randomString = randomString;
exports["default"] = void 0;

/**
 * @module       random
 * @description  Random number and string generators. Part of
 *               ThinkNimble's commonly-used utility functions.
 *
 * @author  William Huster <william@thinknimble.com>
 */
var _default = {
  randBetween: randBetween,
  randomString: randomString
};
/**
 * Generate a random integer between the min and max values.
 *
 * @param {Number} min - The minimum random value to be generated.
 * @param {Number} max - The maximum random value to be generated.
 */

exports["default"] = _default;

function randBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * Generate a random string of characters.
 */


function randomString() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}